exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.carousel[data-v-69ac8adf] {\n  border-radius: 8px 8px 8px 8px;\n  overflow: hidden;\n}\n.carousel-inner div[data-v-69ac8adf] {\n  height: 150px;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-69ac8adf","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/chatBooking/components/BookingSummaryMessage.vue
// module id = 2206
// module chunks = 0